'use client'
import { Montserrat, Open_Sans } from 'next/font/google'
import Image from 'next/image'
import Link from 'next/link'
import { MouseEvent, useEffect } from 'react'

const open = Open_Sans({ weight: '700', subsets: ['latin'] })
const mont = Montserrat({ weight: '400', subsets: ['latin'] })

export default function Navbar() {
  // show dropdown desk item on hover
  const handleShowDrop = (e: MouseEvent<HTMLElement>) => {
    handleClearDrop()
    e.currentTarget.parentElement?.setAttribute('open', 'open')
  }

  // hide all dropdown item
  const handleClearDrop = () => {
    let items = document.getElementsByTagName('details')

    for (let item of items) {
      item.removeAttribute('open')
    }
  }

  // change show/hide of dropdown mobile
  const handleCheckDrop = (e: MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.nextElementSibling?.classList.toggle('hidden')
  }

  // control of navbar items (color and logo) on scroll in mobile and desk
  const controlNavBar = () => {
    const logo = document.getElementById('logo')
    const logoCor = document.getElementById('logo-color')

    const navDesk = document.getElementById('navbar')
    const navMob = document.getElementById('menu-mob')

    const liDesk = document.getElementsByClassName('desk-li')
    const liMob = document.getElementsByClassName('mob-li')

    const btnMob = document.getElementById('btnMob')

    if (window.scrollY > 80) {
      navDesk?.classList.remove('py-4')
      navDesk?.classList.add('bg-white', 'shadow-box-menu', 'py-2')

      logo?.classList.remove('visible')
      logoCor?.classList.remove('hidden')
      logo?.classList.add('hidden')
      logoCor?.classList.add('visible')

      btnMob?.classList.remove('text-white')
      btnMob?.classList.add('text-black')

      navMob?.classList.remove('bg-azul', 'text-white')
      navMob?.classList.add('bg-white', 'text-black')

      for (let li of liDesk) {
        li.classList.remove('text-white')
        li.classList.add('text-black')
      }

      for (let lim of liMob) {
        let item = lim.lastChild as HTMLElement
        item.classList.remove('text-white')
        item.classList.add('text-black')
      }
    } else {
      navDesk?.classList.remove('bg-white', 'shadow-box-menu')
      navDesk?.classList.add('bg-azul', 'py-4')

      for (let li of liDesk) {
        li.classList.remove('text-black')
        li.classList.add('text-white')
      }

      for (let lim of liMob) {
        let item = lim.lastChild as HTMLElement
        item.classList.remove('text-black')
        item.classList.add('text-white')
      }

      logo?.classList.remove('hidden')
      logoCor?.classList.remove('visible')
      logo?.classList.add('visible')
      logoCor?.classList.add('hidden')

      btnMob?.classList.remove('text-black')
      btnMob?.classList.add('text-white')

      navMob?.classList.remove('bg-white', 'text-black')
      navMob?.classList.add('bg-azul', 'text-white')
    }
  }

  const controlDropMob = () => {
    let el = document.getElementById('menu-mob')
    el?.classList.add('hideDrop')

    setTimeout(() => {
      el?.classList.remove('hideDrop')
    }, 500)
  }

  useEffect(() => {
    window.addEventListener('scroll', controlNavBar)
    return () => {
      window.removeEventListener('scroll', controlNavBar)
    }
  }, [])

  return (
    <header
      style={open.style}
      className="navbar sticky top-0 z-90 bg-azul py-4"
      id="navbar"
      onMouseLeave={handleClearDrop}
    >
      <div className="container mx-auto w-full max-w-screen-2xl">
        <nav
          className="navbar-start flex w-full justify-between lg:justify-start"
          onMouseLeave={handleClearDrop}
        >
          {/* menu mobile */}
          <div className="dropdown inline-block lg:hidden">
            <label
              tabIndex={0}
              className="btn btn-ghost text-white lg:hidden"
              id="btnMob"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu dropdown-content menu-sm z-[1] mt-3 w-[340px] rounded-none border-2 border-transparent border-t-amarelo bg-azul p-2 text-white shadow"
              id="menu-mob"
            >
              <li className="mob-li text-xs uppercase">
                <a
                  className="hover:!bg-transparent hover:!text-amarelo"
                  onClick={handleCheckDrop}
                  href="#"
                >
                  a faculdade
                </a>
                <ul
                  style={mont.style}
                  className="hidden w-3/4 border-l-2 border-l-amarelo p-2 capitalize text-white"
                >
                  <li>
                    <Link
                      href="/a-instituicao"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      {' '}
                      A Instituição
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://metroshop.faculdademetropolitana.edu.br/?utm_source=site&utm_medium=site&utm_campaign=metroshop-menu"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Metro Shop
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/bolsa-santander"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Bolsa Santander
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/calendario-academico-2025"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Calendário Acadêmico
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/calendario-academico-2025-presencial"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Calendário Acadêmico Presencial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/metropolitana-university"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Metropolitana University
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/napsi"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      NAPsi
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/ouvidoria"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Ouvidoria
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/portaria_mec"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Portarias MEC
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/portal-egresso"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Portal Egresso
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/processo_seletivo_2025_2_ead"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Processo Seletivo 2025/2 – EAD
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/processo_seletivo_2025_2_presencial"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Processo Seletivo 2025/2 – Presencial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/regimento_geral"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Regimento Geral
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/relatorio-transparencia-salarial"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Relatório de Transparência Salarial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/validar-documento"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul active:font-bold active:!text-amarelo"
                    >
                      Validar Documento
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="mob-li text-xs uppercase">
                <Link
                  href="/infraestrutura"
                  className="hover:!bg-transparent hover:!text-amarelo focus:!bg-transparent"
                  onClick={controlDropMob}
                >
                  infraestrutura
                </Link>
              </li>
              <li className="mob-li text-xs uppercase">
                <a
                  className="hover:!bg-transparent hover:!text-amarelo"
                  onClick={handleCheckDrop}
                  href="#"
                >
                  pesquisa
                </a>
                <ul
                  style={mont.style}
                  className="hidden w-2/3 border-l-2 border-l-amarelo p-2 capitalize text-white"
                >
                  <li>
                    <Link
                      href="/iniciacao-cientifica"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                        active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Iniciação Científica
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/internacionalizacao"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Internacionalização
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://periodicos.faculdademetropolitana.edu.br/"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                    >
                      Portal de Periódicos
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="revistas"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Revistas
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/edital-monitoria-2024"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                    >
                      Edital de Monitoria 2024
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="mob-li text-xs uppercase">
                <a
                  className="hover:!bg-transparent hover:!text-amarelo"
                  onClick={handleCheckDrop}
                  href="#"
                >
                  autoavaliação institucional
                </a>
                <ul
                  style={mont.style}
                  className="hidden w-2/3 border-l-2 border-l-amarelo p-2 capitalize text-white"
                >
                  <li>
                    <Link
                      href="/cpa"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      CPA
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/proai"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      ProAI
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/regulamento_proai"
                      target="new"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                    >
                      Regulamento
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="mob-li text-xs uppercase">
                <a
                  className="hover:!bg-transparent hover:!text-amarelo"
                  onClick={handleCheckDrop}
                  href="#"
                >
                  acesso restrito
                </a>
                <ul
                  style={mont.style}
                  className="hidden w-2/3 border-l-2 border-l-amarelo p-2 capitalize text-white"
                >
                  <li>
                    <Link
                      href="/docente"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Docente
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/tutor"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Tutor
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/tecnico-administrativo"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Técnico Administrativo
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/discente"
                      className="focus:!bg-azul focus:!text-amarelo active:!bg-azul
                  active:font-bold active:!text-amarelo"
                      onClick={controlDropMob}
                    >
                      Discente
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <Link href="/">
            <Image
              src="/assets/img/logo-white.png"
              alt="logo"
              width={842}
              height={205}
              className="visible w-52 md:w-56 lg:w-full xl:w-56"
              id="logo"
              loading="eager"
            />
            <Image
              src="/assets/img/logo-menu-color.png"
              alt="logo"
              width={842}
              height={205}
              className="hidden w-52 md:w-56 lg:w-full xl:w-56"
              id="logo-color"
              loading="eager"
            />
          </Link>
        </nav>

        {/* menu desktop */}
        <nav className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1 text-white">
            <li className="desk-li px-2 text-sm uppercase">
              <details>
                <summary
                  className="px-0 after:content-none hover:!bg-transparent hover:!text-amarelo"
                  onMouseEnter={handleShowDrop}
                >
                  a faculdade
                </summary>
                <ul
                  style={mont.style}
                  className="rounded-none border-2 !border-t-amarelo bg-white p-1 capitalize text-black lg:w-64"
                >
                  <li>
                    <Link
                      href="/a-instituicao"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      {' '}
                      A Instituição
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://metroshop.faculdademetropolitana.edu.br/?utm_source=site&utm_medium=site&utm_campaign=metroshop-menu"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Metro Shop
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/prouni"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      {' '}
                      ProUni
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/bolsa-santander"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Bolsa Santander
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/calendario-academico-2025"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Calendário Acadêmico
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/calendario-academico-2025-presencial"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Calendário Acadêmico Presencial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/metropolitana-university"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Metropolitana University
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/napsi"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      NAPsi
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/ouvidoria"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Ouvidoria
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/portaria_mec"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Portarias MEC
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/portal-egresso"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Portal Egresso
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/processo_seletivo_2025_2_ead"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Processo Seletivo 2025/2 – EAD
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/processo_seletivo_2025_2_presencial"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Processo Seletivo 2025/2 – Presencial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/regimento_geral"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Regimento Geral
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/relatorio-transparencia-salarial"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Relatório de Transparência Salarial
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/validar-documento"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Validar Documento
                    </Link>
                  </li>
                </ul>
              </details>
            </li>
            <li className="desk-li px-2 text-sm uppercase">
              <Link
                href="/infraestrutura"
                className="px-0 hover:!bg-transparent hover:!text-amarelo focus:!bg-transparent focus:!text-amarelo"
                onMouseEnter={handleClearDrop}
              >
                infraestrutura
              </Link>
            </li>
            <li className="desk-li px-2 text-sm uppercase">
              <details>
                <summary
                  className="px-0 after:content-none hover:!bg-transparent hover:!text-amarelo"
                  onMouseEnter={handleShowDrop}
                >
                  pesquisa
                </summary>
                <ul
                  style={mont.style}
                  className="rounded-none border-2 !border-t-amarelo bg-white p-1 capitalize text-black lg:w-64"
                >
                  <li>
                    <Link
                      href="/iniciacao-cientifica"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Iniciação Científica
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/internacionalizacao"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Internacionalização
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://periodicos.faculdademetropolitana.edu.br/"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Portal de Periódicos
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/revistas"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Revistas
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/edital-monitoria-2024"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Edital de Monitoria 2024
                    </Link>
                  </li>
                </ul>
              </details>
            </li>
            <li className="desk-li px-2 text-sm uppercase">
              <details>
                <summary
                  className="px-0 after:content-none hover:!bg-transparent hover:!text-amarelo"
                  onMouseEnter={handleShowDrop}
                >
                  autoavaliação institucional
                </summary>
                <ul
                  style={mont.style}
                  className="rounded-none border-2 !border-t-amarelo bg-white p-1 capitalize text-black lg:w-64"
                >
                  <li>
                    <Link
                      href="/cpa"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      CPA
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/proai"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      ProAI
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/regulamento_proai"
                      target="new"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                    >
                      Regulamento
                    </Link>
                  </li>
                </ul>
              </details>
            </li>
            <li className="desk-li px-2 pr-0 text-sm uppercase">
              <details>
                <summary
                  className="px-0 after:content-none hover:!bg-transparent hover:!text-amarelo"
                  onMouseEnter={handleShowDrop}
                >
                  acesso restrito
                </summary>
                <ul
                  style={mont.style}
                  className="w-auto rounded-none border-2 !border-t-amarelo bg-white p-1 capitalize text-black"
                >
                  <li>
                    <Link
                      href="/docente"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Docente
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/tutor"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Tutor
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/tecnico-administrativo"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Técnico Administrativo
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/discente"
                      className="text-xs hover:!bg-white hover:!text-amarelo"
                      onClick={handleClearDrop}
                    >
                      Discente
                    </Link>
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}
